module.exports = __webpack_public_path__ + "static/media/se.ea2a67f5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/se.svg
// module id = 976
// module chunks = 0